import approx from 'approximate-number';
import CommentsIcon from '@mui/icons-material/Forum';
import PropTypes from 'prop-types';
import React, { useMemo } from 'react';

import FlatButton from 'components/FlatButton';

const CommentsButton = ({ comments, title, ...props }) => (
  <FlatButton
    {...props}
    forceLabel
    icon={useMemo(
      () => <CommentsIcon htmlColor='#fff' />,
      [],
    )}
    label={useMemo(
      () => approx(comments) || '0',
      [comments],
    )}
    title={title || 'Comments'}
    lableColor='#fff'
  />
);

CommentsButton.propTypes = {
  ...FlatButton.propTypes,
  comments: PropTypes.number.isRequired,
  title: PropTypes.string,
};

export default CommentsButton;
